import React, { useLayoutEffect, useRef } from 'react';
import { CheckIcon, XMarkIcon } from '@heroicons/react/24/solid';
import './FloatingSelectionActions.css';
import './FloatingControls.css';

const selectionHeights = new Map();
function syncSelectionLane() {
  document.body.classList.toggle('floating-selection-visible', selectionHeights.size > 0);
  if (selectionHeights.size) {
    document.body.style.setProperty('--floating-selection-height', `${Math.max(...selectionHeights.values())}px`);
  } else {
    document.body.style.removeProperty('--floating-selection-height');
  }
}


// Shared action surface; selection and persistence remain owned by the caller.
export default function FloatingSelectionActions({
  label,
  confirmLabel = 'Done',
  onConfirm,
  onCancel,
  disabled = false,
  busy = false,
  confirmIcon: ConfirmIcon = CheckIcon,
}) {
  const surfaceRef = useRef(null);
  useLayoutEffect(() => {
    const surface = surfaceRef.current;
    const measure = () => {
      selectionHeights.set(surface, Math.ceil(surface.getBoundingClientRect().height));
      syncSelectionLane();
    };
    measure();
    const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(measure) : null;
    observer?.observe(surface);
    window.addEventListener('resize', measure);
    return () => {
      observer?.disconnect();
      window.removeEventListener('resize', measure);
      selectionHeights.delete(surface);
      syncSelectionLane();
    };
  }, []);
  return (
    <div ref={surfaceRef} data-floating-control="selection" className="floating-selection-actions" role="group" aria-label={label} aria-busy={busy}>
      <button type="button" className="floating-reorder-done" onClick={onConfirm} disabled={disabled || busy}>
        <ConfirmIcon aria-hidden="true" style={{ width: 16, height: 16 }} />
        {confirmLabel}
      </button>
      {onCancel && (
        <button type="button" className="floating-reorder-done floating-selection-cancel" onClick={onCancel} disabled={busy}>
          <XMarkIcon aria-hidden="true" style={{ width: 16, height: 16 }} />
          Cancel
        </button>
      )}
    </div>
  );
}
